// dependencies imports ⇒
import React, {
  useEffect,
  useCallback,
  useRef,
  useContext,
  useState,
} from "react";
import { useLocation } from "react-router-dom";
//
// assets and scss imports ⇒
import "./dashboardAccounts.scss";
//
// project file imports(UI components) ⇒
import PhysicalConsultationModal from "../../PhysicalConsultation";
import EditProfile from "../../DoctorDashboard/edit-profile";
import SuccessProfileModal from "../../DoctorDashboard/SuccessProfileModal";
import AdminEditConsultantProfile from "../../AdminEditProfile";
import AccountMainContent from "./AccountMainContent/index";
import SlugMessage from "../../DoctorSlug/slugMessage";
import AlertMsgPopup from "../AlertMsgPopup";

import { OnlinePendingLogs } from "../../OnlinePendingLogs";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import {
  APIFILTERLIST,
  APPLICABLE_ROLE,
} from "../../DashboardAppointmentsView/Constant";
import AccountHeader from "./AccountHeader/index";
import { ALL_DOCS_RESOURCES, DOCTOR_STATUS_DATA, SORT_TYPE } from "./constant";
import {
  ADD_UPDATE_APPLIED_FILTERS,
  GET_APPLIED_FILTERS,
  GET_DOCTOR_ACCOUNTS,
} from "./APIHandler/APIConstants";
import { C2CConsole } from "../../../Util/Helper/C2CConsole";
import {
  c2cGetApiHandler,
  c2cPostApiHandler,
} from "../../../Util/c2cApiHandler";
import DoctorContext from "../../ClinicComponents/ClinicWrapper/DoctorContext";
//

const DashboardAccounts = (props) => {
  // const declarations ⇒
  const { doctor_selected, callNextAppointmentWidget, scrollRef } = props;
  const doctor_context = useContext(DoctorContext);
  const location = useLocation();
  const app_start_date = new URLSearchParams(location.search).get(
    APIFILTERLIST.STARTDATE
  );
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const user_type = localStorage.getItem("user_type");
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  const [doctorId, setDoctorId] = useState(null);
  const [contentLoading, setContentLoading] = useState(false);
  const [doctorData, setDoctorData] = useState([]);
  const [showEditProfileModal, setShowEditProfileModal] = useState(false);
  const [showAdminEditProfileModal, setShowAdminEditProfileModal] =
    useState(false);
  const [showShareLink, setShowShareLink] = useState(false);
  const [appointmentType, setAppointmentType] = useState();
  const [showPhysicalConsultationModal, setShowPhysicalConsultationModal] =
    useState(false);
  const [showPendingAppointments, setShowPendingAppointments] = useState(false);
  const [doctorAccount, setDoctorAccount] = useState([]); // display data
  const [showAlertPopup, setShowAlertPopup] = useState(false);
  const [alertMsgPop, setAlertMsgPop] = useState("");
  const [activeStatus, setActiveStatus] = useState("All");
  const [isUpdateProfile, setIsUpdateProfile] = useState(false);
  const [inputText, setInputText] = useState("");
  const [showSort, setShowSort] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [accountFilters, setAccountFilters] = useState([]);
  const [allDocsResourcesList, setAllDocsResourcesList] = useState(
    JSON.parse(JSON.stringify(ALL_DOCS_RESOURCES))
  );
  const [selectedSpecilisations, setSelectedSpeciliaisations] = useState(null);
  const [isFilterOn, setIsFilterOn] = useState(false);
  const [statusOptions, setStatusOptions] = useState(DOCTOR_STATUS_DATA);
  const [sortOrder, setSortOrder] = useState({
    name: "Account Name (A-Z)",
    key: SORT_TYPE.DOCTOR_NAME_A_Z,
    selected: false,
  });
  const [pageNo, setPageNo] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const debounceTimeout = useRef(null);
  const noOfRecords = 10;
  //

  // let or var declarations ⇒
  let defaultPayload = {
    doctor_ids: doctor_selected ? doctor_selected : userId,
  };
  let staffTransformStyle =
    localStorage.getItem(LOCALSTORAGEKEY.STAFF_CLINIC_ASSOCIATION) === "true"
      ? "translate(105px, 98px)"
      : "translate(80px, 39px)";
  let transformStyle =
    localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION) === "true"
      ? "translate(96px, 39px)"
      : staffTransformStyle;
  //

  // Lifecycle methods ==>
  useEffect(() => {
    getFilterDropDownOptions();
  }, [doctor_context]);

  useEffect(() => {
    if (accountFilters?.length > 0 && !filtersApplied) {
      fetchExistedFilters();
    }
  }, [doctorAccount, accountFilters, doctor_selected]);

  useEffect(() => {
    if (doctor_selected?.length > 0 && filtersApplied) {
      getDoctorList();
    }
  }, [inputText, selectedSpecilisations, doctor_selected, app_start_date]);

  const handleScroll = useCallback(
    (e) => {
      const { current } = scrollRef;
      if (current) {
        const reachedBottom =
          current.scrollTop + current.clientHeight >= current.scrollHeight / 2;
        if (reachedBottom && !contentLoading) {
          clearTimeout(debounceTimeout.current);
          e.preventDefault();
          debounceTimeout.current = setTimeout(() => {
            loadNext();
          }, 400);
        }
      }
    },
    [contentLoading]
  );

  useEffect(() => {
    const { current } = scrollRef;
    if (current) {
      current.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (current) {
        current.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);
  // <===

  // API Calls ==>
  const getFilterDropDownOptions = () => {
    if (doctor_context.selectedDoctor.length !== 0) {
      let arr = [];
      doctor_context?.selectedDoctor &&
        doctor_context.selectedDoctor.map(
          (data) => data?.selected === true && arr.push(data)
        );
      afterFetchingOptions(arr);
    }
  };

  const getDoctorList = async (
    appliedSpecialisation,
    sort,
    status,
    pageno,
    paging = false
  ) => {
    setContentLoading(true);
    let data = {
      ...defaultPayload,
      clinic_id: clinicId,
      staff_id: staffId,
      date_selected: app_start_date,
      search_string: inputText,
      page_no: pageno ? pageno : pageNo,
      filter_room_status: status
        ? status?.toLowerCase()
        : activeStatus
        ? activeStatus?.toLowerCase()
        : "all",
      sort_option: sort
        ? sort?.key
        : sortOrder.key
        ? sortOrder.key
        : SORT_TYPE.DOCTOR_NAME_A_Z,
      specialization_ids: getSelectedSpecilisations(),
      no_of_records: noOfRecords,
    };

    let res = await c2cPostApiHandler(GET_DOCTOR_ACCOUNTS, data);
    let [response, err] = res;
    if (!err) {
      let [list, count] = getModifiedDocterList(response);
      if (typeof count === "number") {
        setTotalCount(count);
      } else {
        setTotalCount(0);
      }
      if (list?.length > 0 && count) {
        if (paging) {
          setDoctorAccount((prev) => [...prev, ...list]);
        } else {
          setDoctorAccount([...list]);
        }
      } else {
        setDoctorAccount([]);
      }
      setContentLoading(false);
    }
  };

  const fetchExistedFilters = async () => {
    let reqPayload = {
      "authorizer-principal-id": {
        user_id: userId,
      },
    };
    let params = {
      section_type: "DoctorAccounts",
      clinic_id: clinicId ? clinicId : staffId,
      user_id: user_type === APPLICABLE_ROLE.DOCTOR ? userId : staffId,
    };
    setContentLoading(true);
    const [res] = await c2cGetApiHandler(
      GET_APPLIED_FILTERS,
      params,
      reqPayload
    );
    setContentLoading(false);
    if (res) {
      if (res?.data?.statusCode === 200) {
        let resData = res?.data?.data[0];
        afterFetchingFilters(resData);
      }
    }
  };

  const updateCurrentFilter = (activeState, sort, specilisations) => {
    let filters = {
      filter_options: {
        specialization_filter:
          isSpecilisationsSelected(specilisations) && specilisations,
        status_filter: activeState,
        sort_options: sort,
      },
    };
    let reqPayload = {
      user_id: user_type === APPLICABLE_ROLE.DOCTOR ? userId : staffId,
      clinic_id: clinicId || staffId,
      ...filters,
    };
    const addUpdateAppliedFilterResponse = c2cPostApiHandler(
      ADD_UPDATE_APPLIED_FILTERS,
      reqPayload
    );
    addUpdateAppliedFilterResponse.then(([res, error]) => {
      if (!error) {
        C2CConsole.log("res", res);
      }
    });
  };
  // ==>

  // Helper methods ==>

  const getModifiedDocterList = (res) => {
    let doctorList = [];
    if (res.data.statusCode === 200 && res.data.data.length > 0) {
      res.data.data.map((da) => {
        return (
          (da.dr_name = `${
            da?.doctor_prefix_name ? da.doctor_prefix_name + "." : ""
          } ${
            "" +
            da?.doctor_first_name +
            (da?.doctor_middle_name
              ? " " + da?.doctor_middle_name + " "
              : " ") +
            da?.doctor_last_name
          }
           `),
          (da.room_status = da.room_status ? da.room_status : "out")
        );
      });

      doctorList = [res.data.data, res.data.total_count];
    } else {
      doctorList = [[], 0];
    }
    return doctorList;
  };

  const afterFetchingOptions = async (list) => {
    let arr = [];
    list.forEach((obj) => {
      let allow = arr.findIndex(
        (ar) => ar.specialisation_id === obj.specialization_id
      );
      if (allow == -1) {
        arr.push({
          specialisation_name:
            obj.account_type === "0"
              ? obj?.specialization
              : obj.account_type === "1"
              ? obj?.doctor_name
              : "",
          selected: false,
          specialisation_id: obj.specialization_id,
        });
      }
    });
    setAccountFilters(arr);
  };

  const afterFetchingFilters = (resData) => {
    // Sorting
    let sortOpt = resData?.filter_options?.sort_options
      ? resData?.filter_options?.sort_options
      : {
          name: "Account Name (A-Z)",
          key: SORT_TYPE.DOCTOR_NAME_A_Z,
          selected: false,
        };
    let options = [...statusOptions];
    let foundOption = options.find((opt) => opt.key === sortOpt.key);
    if (foundOption) {
      setSortOrder(foundOption);
    }
    let selected = options.map((opt) => {
      opt.selected = opt.key === sortOpt.key;
      return opt;
    });
    setStatusOptions(selected);
    //  active status
    let filterOpt = resData?.filter_options?.status_filter
      ? resData?.filter_options?.status_filter
      : "All";
    setActiveStatus(filterOpt);
    let appliedSpecialisation = resData?.filter_options?.specialization_filter;
    if (appliedSpecialisation === "") {
      let selectedOptions = allDocsResourcesList?.map((op) => {
        op.selected = op.value === "";
        return op;
      });
      setAllDocsResourcesList(selectedOptions);
    } else if (
      Array.isArray(appliedSpecialisation) &&
      accountFilters?.length > 0
    ) {
      let accFilters = [...accountFilters];
      accFilters.forEach((obj) => {
        obj.selected = appliedSpecialisation.includes(obj.specialisation_id);
      });
      setAccountFilters(accFilters);
    } else if (typeof appliedSpecialisation === "number") {
      let selectedOptions = allDocsResourcesList?.map((op) => {
        op.selected = op.value === appliedSpecialisation;
        return op;
      });
      setAllDocsResourcesList(selectedOptions);
    }
    if (
      typeof appliedSpecialisation === "number" ||
      appliedSpecialisation?.length > 0
    ) {
      setIsFilterOn(true);
    } else {
      setIsFilterOn(false);
    }
    if (accountFilters?.length > 0) {
      setFiltersApplied(true);
      getDoctorList(null, sortOpt, filterOpt, 1);
    }
  };

  const getSelectedSpecilisations = () => {
    let isDocResourceSelected = allDocsResourcesList?.some(
      (obj) => obj.selected
    );
    if (isDocResourceSelected) {
      let selectedObj = allDocsResourcesList?.find((obj) => obj.selected);
      return selectedObj.value;
    }
    let ids = [];
    accountFilters.map((obj) => {
      if (obj.selected) {
        ids.push(obj.specialisation_id);
      }
    });

    return ids?.length > 0 ? ids : "";
  };

  // ===>

  // Actions ==>

  const scrollToTop = useCallback(() => {
    const { current } = scrollRef;
    if (current) {
      current.scrollTop = 0;
    }
  }, []);

  const onSubmit = (val) => {
    setPageNo(1);
    setInputText(val);
  }; // search doctor

  const updateRoomNumberCallBack = (data) => {
    let duplicatedList = [...doctorAccount];
    let foundCardIndx = duplicatedList?.findIndex(
      (obj) => obj?.doctor_id === data?.doctor_id
    );
    if (foundCardIndx > -1) {
      duplicatedList[foundCardIndx].room_name = data?.room_name;
    }
    setDoctorAccount(duplicatedList);
  };

  const handleEditProfileShow = (data) => {
    setDoctorId(data.doctor_id);
    setDoctorData(data);
    setShowEditProfileModal(true);
  }; // open update profile

  const handleAdminEditProfileShow = (data) => {
    setDoctorId(data.doctor_id);
    setDoctorData(data);
    setShowAdminEditProfileModal(true);
  }; // open update profile

  const handleShareLinkClick = (data) => {
    setDoctorData(data);
    setShowShareLink(true);
  }; // open share link popup

  const handleOnlineClick = (data) => {
    setDoctorData(data);
    setAppointmentType("online");
    setShowPhysicalConsultationModal(true);
  }; // book online appointments

  const handleInClinicClick = (data) => {
    setDoctorData(data);
    setAppointmentType("in-clinic");
    setShowPhysicalConsultationModal(true);
  }; // book inclinic appointments

  const toggleRoomStatus = (id, status) => {
    let index = doctorAccount.findIndex((da) => da.doctor_id === id);
    doctorAccount[index].room_status = status;
    setDoctorAccount([...doctorAccount]);
  };
  const loadNext = () => {
    if (pageNo < totalCount / noOfRecords && !contentLoading) {
      setPageNo(pageNo + 1);
      getDoctorList(null, sortOrder, activeStatus, pageNo + 1, true);
    }
  };

  const handleClosePendingAppointmentsDrawer = () => {
    setShowPendingAppointments(false);
  }; // close pending appointments

  const showSetAppointmentType = (onlineAppointment) => {
    setShowAlertPopup(true);
    setTimeout(() => {
      setShowAlertPopup(false);
    }, 2000);
    if (onlineAppointment) {
      setAlertMsgPop("Link Shared Successfully");
    } else {
      setAlertMsgPop("Appointment Booked Successfully");
    }
  };
  const handleAdminEditProfileClose = (message) => {
    setShowAdminEditProfileModal(false);
    showEditProfileMsg(message);
  }; // close update profile

  const showEditProfileMsg = (message) => {
    if (message === "updateSuccess") {
      setIsUpdateProfile(true);
      getDoctorList(null, sortOrder, activeStatus, 1);
      setTimeout(() => {
        setIsUpdateProfile(false);
      }, 2000);
    }
  };
  const handleCloseShareLinkDrawer = () => {
    setShowShareLink(false);
  }; // close share link popup

  const toggleDrawer = () => {
    setShowShareLink(!showShareLink);
  }; // toggle share link popup

  const handleEditProfileClose = (message) => {
    setShowEditProfileModal(false);
    showEditProfileMsg(message);
  }; // close update profile

  const accountsClickHandler = (name) => {
    setActiveStatus(name);
    setPageNo(1);
    updateCurrentFilter(name, sortOrder, getSelectedSpecilisations());
    getDoctorList(null, sortOrder, name, 1);
    scrollToTop();
  };

  const toggleSort = () => {
    setShowSort(!showSort);
    setShowFilter(false);
  };

  const handleApplySort = (val) => {
    setSortOrder(val);
    setShowSort(false);
    let options = [...statusOptions];
    let selected = options.map((opt) => {
      opt.selected = opt.key === val.key;
      return opt;
    });
    setStatusOptions(selected);
    setPageNo(1);
    updateCurrentFilter(activeStatus, val, getSelectedSpecilisations());
    scrollToTop();
    getDoctorList(null, val, activeStatus, 1);
  };

  const toggleFilter = () => {
    setShowSort(false);
    setShowFilter(!showFilter);
  }; // toggle specialization filter

  const handlePendingAppointmentLogs = () => {
    setShowPendingAppointments(true);
  }; // open pending appointments

  const toggleSpecilisation = (item) => {
    let accFilters = [...accountFilters];
    accFilters.forEach((obj) => {
      if (obj.specialisation_id === item.specialisation_id) {
        obj.selected = !obj.selected;
      }
    });
    setAccountFilters(accFilters);
    let docSourceList = [...allDocsResourcesList];
    docSourceList.forEach((object) => {
      object.selected = false;
    });
    setAllDocsResourcesList(docSourceList);
  }; // toggle specialization filter

  const onDocResourcesClick = (obj) => {
    let docSourceList = [...allDocsResourcesList];
    docSourceList.forEach((object) => {
      if (object === obj) {
        object.selected = !obj.selected;
      } else {
        object.selected = false;
      }
    });
    setAllDocsResourcesList(docSourceList);
    let accFilters = [...accountFilters];
    accFilters.forEach((ele) => {
      ele.selected = false;
    });
    setAccountFilters(accFilters);
  };

  const isSpecilisationsSelected = (specilisations) => {
    return (
      specilisations === "" ||
      typeof specilisations === "number" ||
      specilisations?.length > 0
    );
  };
  const handleApplyFilter = () => {
    let specilisations = getSelectedSpecilisations();
    setSelectedSpeciliaisations(specilisations);
    setShowFilter(false);
    setPageNo(1);
    if (isSpecilisationsSelected(specilisations)) {
      updateCurrentFilter(activeStatus, sortOrder, specilisations);
    }
    if (typeof specilisations === "number" || specilisations?.length > 0) {
      setIsFilterOn(true);
    } else {
      setIsFilterOn(false);
    }
    scrollToTop();
  };

  const handleResetAll = () => {
    let accFilters = [...accountFilters];
    accFilters.forEach((obj) => {
      obj.selected = false;
    });
    setAccountFilters(accFilters);
    let docSourceList = [...allDocsResourcesList];
    docSourceList.forEach((object) => {
      object.selected = object.value === "";
    });
    setAllDocsResourcesList(docSourceList);
    setShowFilter(false);
    setIsFilterOn(false);
    setPageNo(1);
    updateCurrentFilter(activeStatus, sortOrder, getSelectedSpecilisations());
    let specilisations = getSelectedSpecilisations();
    setSelectedSpeciliaisations(specilisations);
    scrollToTop();
  };

  // ==>

  return (
    <>
      <div className="pl-3">
        <AccountHeader
          inputText={inputText}
          onChange={onSubmit}
          doctorAccount={doctorAccount}
          filterApplied={isFilterOn}
          sortApplied={
            sortOrder?.key && sortOrder?.key !== SORT_TYPE.DOCTOR_NAME_A_Z
          }
          toggleFilter={toggleFilter}
          toggleSort={toggleSort}
          totalCount={totalCount}
          showSort={showSort}
          showFilter={showFilter}
          accountFilters={accountFilters}
          activeButton={activeStatus}
          doctorStatusData={statusOptions}
          allDocsResourcesList={allDocsResourcesList}
          handleResetAll={handleResetAll}
          handleApplyFilter={handleApplyFilter}
          transformStyle={transformStyle}
          handleApplySort={handleApplySort}
          getDoctorList={getDoctorList}
          handlePendingAppointmentLogs={handlePendingAppointmentLogs}
          accountsClickHandler={accountsClickHandler}
          toggleSpecilisation={toggleSpecilisation}
          onDocResourcesClick={onDocResourcesClick}
        />
        <AccountMainContent
          doctorAccount={doctorAccount}
          contentLoading={contentLoading}
          scrollRef={scrollRef}
          updateRoomNumberCallBack={updateRoomNumberCallBack}
          handleEditProfileShow={handleEditProfileShow}
          handleAdminEditProfileShow={handleAdminEditProfileShow}
          handleShareLinkClick={handleShareLinkClick}
          handleOnlineClick={handleOnlineClick}
          handleInClinicClick={handleInClinicClick}
          toggleRoomStatus={toggleRoomStatus}
          loadNext={loadNext}
        />
        {showPendingAppointments && (
          <OnlinePendingLogs
            openPopup={showPendingAppointments}
            closeDrawerCallback={handleClosePendingAppointmentsDrawer}
          />
        )}
        <SlugMessage
          show={showShareLink}
          onClose={handleCloseShareLinkDrawer}
          toggleDrawer={toggleDrawer}
          name={doctorData.dr_name}
          slug={doctorData.short_url_slug}
          closeSlugModal={handleCloseShareLinkDrawer}
          isDoctorId={true}
          doctorId={doctorData.doctor_id}
        />
        {showPhysicalConsultationModal && (
          <PhysicalConsultationModal
            appointmentType={appointmentType} //appointmentType
            doctor_slug={""} //profile?.short_url_slug
            closeView={() => {
              setShowPhysicalConsultationModal(false);
            }}
            openView={showPhysicalConsultationModal}
            isAddMode={true}
            step={1}
            doctorData={doctorData}
            callNextAppointmentWidget={callNextAppointmentWidget}
            handleSetAppointmentType={showSetAppointmentType}
            dashboardSelectedDate = {app_start_date}
          />
        )}
        {showAlertPopup && <AlertMsgPopup alertMsg={alertMsgPop} />}
        {showEditProfileModal && (
          <EditProfile
            openView={showEditProfileModal}
            doctorId={doctorId}
            id="doctor_edit_profile"
            closeView={handleEditProfileClose}
          />
        )}
        {showAdminEditProfileModal && (
          <AdminEditConsultantProfile
            doctorData={doctorData}
            openView={showAdminEditProfileModal}
            doctorId={doctorId}
            clinicId={clinicId}
            closeView={handleAdminEditProfileClose}
          />
        )}
        {isUpdateProfile && <SuccessProfileModal show={isUpdateProfile} />}
      </div>
    </>
  );
};

export default DashboardAccounts;
